import { UserDataState } from "../../types";

import { useTypedSelector } from ".";

export const useUserDataState = (): UserDataState | null =>
  useTypedSelector(state => state.user.data);
